import { useEffect } from "react";

import { swSettings } from "app/common/services/swSettings";
import { PopUpSwitchPackage } from "app/components/PackageSwitcher/components/PopUpSwitchPackage";
import type { FeatureArea } from "app/components/PackageSwitcher/consts/packageFeatureInfo";
import { PaymentPeriod } from "app/components/PackageSwitcher/consts/paymentPeriod";
import { MESSAGE_TYPE_DICT, useMessagesContext } from "app/contexts/MessagesContext/MessagesContext";
import { useSwitchPackagePopup } from "app/custom-hooks/switchPackage/useSwitchPackagePopup";
import { isMonthlyPaymentPeriod } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

interface ISwitchPackagePayload {
    targetPackage: string;
    area: FeatureArea;
    hookTrackingKey: string;
}

export const PackageSwitcherContainer = () => {
    const { register } = useMessagesContext();

    const {
        isPopupOpen,
        setIsPopupOpen,
        targetPaymentPeriod,
        isLoading,
        error,
        switchInformationData,
        availableAddOns,
        featureArea: selectedFeatureArea,
        hookTrackingKey,
        triggerPopup,
    } = useSwitchPackagePopup();

    useEffect(() => {
        if (register) {
            const switchTargetPeriod = isMonthlyPaymentPeriod(swSettings)
                ? PaymentPeriod.MONTHLY
                : PaymentPeriod.ANNUAL;

            return register<ISwitchPackagePayload>(MESSAGE_TYPE_DICT.switchPackage, (event) => {
                const { targetPackage, area, hookTrackingKey: key } = event.data.payload;
                triggerPopup(targetPackage, switchTargetPeriod, area, key);
            });
        }
    }, [register, triggerPopup]);

    return isPopupOpen && targetPaymentPeriod && selectedFeatureArea && hookTrackingKey ? (
        <PopUpSwitchPackage
            isLoading={isLoading}
            isError={Boolean(error)}
            targetPackagePeriod={targetPaymentPeriod}
            switchInformationData={switchInformationData}
            setIsPopUpOpen={setIsPopupOpen}
            availableAddOns={availableAddOns}
            featureArea={selectedFeatureArea}
            hookTrackingKey={hookTrackingKey}
        />
    ) : null;
};
